import { useAuiState } from "@assistant-ui/react";
import React from "react";
import { MemoizedMarkdown } from "../../../MemoizedMarkdown";
import styles from "./UserQuestionMessage.scss";

// Reads its own text from the message context (provided by
// ThreadPrimitive.Messages). User prompts are plain text; multiple text parts
// are joined defensively — mirroring the previous getMessageText helper.
const selectUserText = (state) =>
    state.message.content
        .filter((part) => part.type === "text")
        .map((part) => part.text)
        .join("\n")
        .trim();

export const UserQuestionMessage = () => {
    const text = useAuiState(selectUserText);

    return (
        // data-user-message: scroll-anchor hook — after sending, the app
        // anchors the newest prompt near the top of the viewport.
        <div className={styles.base} data-user-message="">
            <div className={styles.text}>
                <MemoizedMarkdown content={text} />
            </div>
        </div>
    );
};
